export const SETTLEMENT_REQUESTS_ITEMS_RESET_STATE = 'SETTLEMENT_REQUESTS_ITEMS_RESET_STATE';
export const SETTLEMENT_REQUESTS_ITEMS_CURRENT_ITEM = 'SETTLEMENT_REQUESTS_ITEMS_CURRENT_ITEM';

export const SETTLEMENT_REQUESTS_ITEMS_REQUEST_LOADING = 'SETTLEMENT_REQUESTS_ITEMS_REQUEST_LOADING';
export const SETTLEMENT_REQUESTS_ITEMS_REQUEST_SUCCESS = 'SETTLEMENT_REQUESTS_ITEMS_REQUEST_SUCCESS';
export const SETTLEMENT_REQUESTS_ITEMS_REQUEST_FAILED = 'SETTLEMENT_REQUESTS_ITEMS_REQUEST_FAILED';

export const SETTLEMENT_REQUESTS_ITEMS_CURRENT_ACTION = 'SETTLEMENT_REQUESTS_ITEMS_CURRENT_ACTION';
export const SETTLEMENT_REQUESTS_ITEMS_RESET_ACTION = 'SETTLEMENT_REQUESTS_ITEMS_RESET_ACTION';